import { z } from 'zod';
import { ChatUserRefSchema } from './chat-user-ref.js';
import { PlatformSchema } from './platform.js';

export const ChatMessageSchema = z.object({
  type: z.literal('message'),
  platform: PlatformSchema,
  externalId: z.string().min(1),
  liveChatId: z.string().min(1),
  author: ChatUserRefSchema,
  text: z.string(),
  timestamp: z.number().int().nonnegative(),
  isModerator: z.boolean().default(false),
  isBroadcaster: z.boolean().default(false),
});
export type ChatMessage = z.infer<typeof ChatMessageSchema>;

export const ChatPlatformEventSchema = z.object({
  type: z.literal('platform'),
  platform: PlatformSchema,
  liveChatId: z.string().min(1),
  kind: z.enum(['sub', 'superchat', 'raid', 'host', 'announcement']),
  payload: z.unknown(),
  timestamp: z.number().int().nonnegative(),
});
export type ChatPlatformEvent = z.infer<typeof ChatPlatformEventSchema>;

export const ChatConnectionEventSchema = z.object({
  type: z.literal('connection'),
  platform: PlatformSchema,
  liveChatId: z.string().min(1),
  subtype: z.enum(['connecting', 'connected', 'reconnecting', 'disconnected']),
  reason: z.enum(['live_ended', 'auth', 'network', 'rate_limit', 'unknown', 'quota_exhausted', 'detached']).optional(),
  attempt: z.number().int().nonnegative().optional(),
  retryInMs: z.number().int().nonnegative().optional(),
  timestamp: z.number().int().nonnegative(),
});
export type ChatConnectionEvent = z.infer<typeof ChatConnectionEventSchema>;

export const ChatEventSchema = z.discriminatedUnion('type', [
  ChatMessageSchema,
  ChatPlatformEventSchema,
  ChatConnectionEventSchema,
]);
export type ChatEvent = z.infer<typeof ChatEventSchema>;
